<template>
  <div class="game-progressbar" :class="{ 'game-progressbar--in-app' : $inApp }">
    <span class="game-progressbar__container">
      <span
        class="game-progressbar__progress"
        :style="{ width: `${$store.state.fuel}%` }"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: 'GameProgressbar',
};
</script>

<style lang="scss" scoped>
.game-progressbar {
  position: relative;

  @include mq($until: ipadP) {
    position: fixed;
    top: 27px;
    left: 26vw;

    &.game-progressbar--in-app {
      top: 52px;
    }

    .game-progressbar__container {
      margin: 0;
    }
  }

  &__container {
    display: inline-block;
    position: relative;
    width: 48vw;
    height: 20px;
    margin-top: 5px;
    margin-left: -15px;

    background-color: #B47B42;
    transform-origin: left center;
    transition: transform 0.1s linear;

    border: 2px solid $color-black;
    border-radius: 15px;
    box-shadow: $button-shadow-small;

    overflow: hidden;

    @include mq(ipadP) {
      width: 150px;
      min-width: 150px;
    }

    @include mq(ipadL) {
      width: 14vw;
    }

    .game-progressbar__progress {
      position: absolute;
      top: -2px;
      left: 0;
      width: 100%;
      height: calc(100% + 4px);

      border-radius: 15px;
      background-color: #EB4ADA;
      border: 2px solid $color-black;

      transition: width 0.35s ease-out;
    }
  }
}
</style>
